<template>
<a
  class="btn btn-info btn-fill btn-wd"
  @click="handlePrintTerm()"
>
  Download Termo
</a>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'button-download-term-lamps',

  props: {
    eventId: { required: true, type: String },
    customer: { required: true },
    lamps: { required: true },
    event: { required: true }
  },

  computed: {
    ...mapGetters('project', ['project'])
  },

  methods: {
    handlePrintTerm () {
      let payload = {
        customer: this.customer,
        lamps: this.lamps,
        eventId: this.eventId,
        companyTerms: this.event.companyTerms || this.project.companyTerms
      }
      localStorage.removeItem('LampsTmpTemp')
      localStorage.setItem('LampsTmpTemp', JSON.stringify(payload))
      let routeData = this.$router.resolve({ name: 'lamps.print' })
      window.open(
        routeData.href,
        'ticketWindow',
        'menubar=false,location=false,resizable=false,scrollbars=1,status=false'
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Lamps/ButtonDownloadTermLamps.vue